import { AfterViewInit, Component, computed, ElementRef, inject, input, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AutofocusDirective } from 'app/shared/form-utils/autofocus.directive';
import { ButtonDirective } from 'app/shared/ui/buttons/button.component';
import { ModalBodyComponent } from 'app/shared/ui/modals/modal-body.component';
import { ModalFooterComponent } from 'app/shared/ui/modals/modal-footer.component';
import { ModalHeaderComponent } from 'app/shared/ui/modals/modal-header.component';
import { ModalComponent } from 'app/shared/ui/modals/modal.component';
import { OverlayRef } from '../overlays';
import { DialogType } from './dialog-type.model';


@Component({
    selector: 'alert-modal',
    imports: [
        AutofocusDirective,
        ButtonDirective,
        ModalHeaderComponent,
        ModalBodyComponent,
        ModalFooterComponent,
        ModalComponent,
    ],
    template: `
        <ui-modal>
            @if (header()) {
                <modal-header [type]="type()">
                    {{ header() }}
                </modal-header>
            }
            <modal-body><div [innerHTML]="safeContent()"></div></modal-body>
            <modal-footer>
                <button class="btn btn-secondary" (click)="close()" autofocus>
                    Close
                </button>
            </modal-footer>
        </ui-modal>
    `,
})
export class AlertDialogComponent implements AfterViewInit {

    type = input<DialogType>('info');

    header = input('Notification');

    content = input<string>('');

    private ds = inject(DomSanitizer);

    safeContent = computed(() => this.ds.bypassSecurityTrustHtml(this.content()));

    private overlayRef = inject(OverlayRef);

    private el = inject(ElementRef);

    private renderer = inject(Renderer2);

    private router = inject(Router);

    ngAfterViewInit() {
        const navigationElements = Array.prototype.slice.call(this.el.nativeElement.querySelectorAll('a[routerLink]'));
        navigationElements.forEach((elem: any) => {
            // angular doesn't support routerLink in innerHTML, therefore this hack
            // https://github.com/ngx-translate/core/issues/512#issuecomment-309476512
            // TODO: remove use custom alert modals instead
            this.renderer.listen(elem, 'click', event => {
                event.preventDefault();
                this.router.navigate([elem.getAttribute('routerLink')]);
                this.close();
            });
        });
    }

    close() {
        this.overlayRef.dismiss('close');
    }
}
